export default __webpack_public_path__ + "static/media/Front-Al-Rassoul-Al-Aazzam-Hospital.c4e50f1c.jpg";